// Auto-generated relationship registry
// Maps Neo4j relationship type names to relationship classes
// DO NOT EDIT - Changes will be overwritten

import type { RelationshipClass } from '@sourcepilot/framework/relationship';
import {

  ActionBindsParameter,

  ActionComposedOf,

  ActionHasInputParameters,

  ActionHasOutputParameters,

  ActionParameterTypedBy,

  ActionVerifiesRequirement,

  Allocation,

  AnalysesContent,

  AnalysisRecordOfProject,

  AtScope,

  AttributeInWorkspace,

  AttributeValueHasUnitOverride,

  AttributeValueOfAttribute,

  BelongsToIndustry,

  BelongsToWorkspace,

  CatalogAt,

  ChangeImpactOfProject,

  ChangeProposalInBatch,

  ConcernHasStakeholder,

  ConnectionEndA,

  ConnectionEndB,

  ConstraintHasChildConstraints,

  ContainsAction,

  ContainsLogicalPart,

  ContainsPackage,

  ContainsPhysicalPart,

  ContributesTo,

  CreatedBy,

  CurrentTaskAttachedTo,

  Derivation,

  DerivedFromUnit,

  DerivedValueOfAttribute,

  DerivedValueOfExpression,

  DesignsPackage,

  EditsNode,

  ExpandsNode,

  ExtractsNode,

  FlowConnection,

  Formalises,

  FramesConcern,

  GeneratesNode,

  GlossaryTermInWorkspace,

  GroupAt,

  HasActions,

  HasAnswer,

  HasAttribute,

  HasAttributeValue,

  HasConstraints,

  HasContentObject,

  HasContext,

  HasDerivedValue,

  HasExpression,

  HasExpressionInputs,

  HasInterfacePort,

  HasMembers,

  HasModelRequestResponse,

  HasModelRequests,

  HasPorts,

  HasProduct,

  HasQuestionnaire,

  HasQuestions,

  HasRFLPProject,

  HasRequirement,

  HasRequirements,

  HasResponse,

  HasRootPart,

  HasSource,

  HasStakeholderNeed,

  HasSteps,

  HasSubRequirements,

  HasSupplyChainCriteria,

  HasThread,

  HasThreads,

  InviteTo,

  IsPart,

  IslandHoldsPin,

  ItemFlowMeasuredIn,

  ItemFlowRealizedBy,

  ItemFlowSourceParameter,

  ItemFlowTargetParameter,

  ItemFlowTypedBy,

  ItemHasCanonicalUnit,

  ItemInWorkspace,

  LPBindsBehavioralPort,

  LPHasBehavioralPort,

  MBSE_Allocates,

  MBSE_Attributes,

  MBSE_Bind,

  MBSE_Delegation,

  MBSE_Derivation,

  MBSE_Flows,

  MBSE_MainFunction,

  MBSE_Ports,

  MBSE_Refinement,

  MBSE_Requirements,

  MBSE_RootPart,

  MBSE_Satisfaction,

  MBSE_SubactionOf,

  MBSE_SubpartOf,

  MemberOf,

  MemberOfClosure,

  Mentions,

  NeedHasStakeholder,

  NeedTransformedToRequirement,

  NumericAttributeHasCanonicalUnit,

  OfIsland,

  OperatesOn,

  OwnedByUser,

  Owns,

  ParentScope,

  PartBindsInterfacePort,

  PartComposedOf,

  Performs,

  ProjectHasRootPart,

  ProposalBatchFromChangeImpact,

  ProposalBatchOfProject,

  RFLPAllocation,

  RFLPPerforms,

  RealizedByProject,

  RealizesConnection,

  ReferencesNode,

  Refinement,

  RequirementConflictsWith,

  RequirementDerives,

  RequirementHasStakeholder,

  RequirementPart,

  RequirementRefines,

  Satisfaction,

  Satisfies,

  SourceDocumentInWorkspace,

  Specializes,

  StandardForInterfacePort,

  StandardInWorkspace,

  SubTaskOf,

  SuccessionScopedIn,

  SuccessionSourceAction,

  SuccessionTargetAction,

  ToolResponsesSentIn,

  TriggeredByToolCall,

  UnitInWorkspace,

  UsesSystemPromptForRequest,

  WritesTo

} from '../relationships/relationship';

/**
 * Registry mapping Neo4j relationship type names to relationship metadata classes.
 * Each class contains full bidirectional metadata including origin_property, dest_property, and cardinality.
 */
export const RelationshipRegistry: Record<string, RelationshipClass> = {

  'ActionBindsParameter': ActionBindsParameter,

  'ActionComposedOf': ActionComposedOf,

  'ActionHasInputParameters': ActionHasInputParameters,

  'ActionHasOutputParameters': ActionHasOutputParameters,

  'ActionParameterTypedBy': ActionParameterTypedBy,

  'ActionVerifiesRequirement': ActionVerifiesRequirement,

  'Allocation': Allocation,

  'AnalysesContent': AnalysesContent,

  'AnalysisRecordOfProject': AnalysisRecordOfProject,

  'AtScope': AtScope,

  'AttributeInWorkspace': AttributeInWorkspace,

  'AttributeValueHasUnitOverride': AttributeValueHasUnitOverride,

  'AttributeValueOfAttribute': AttributeValueOfAttribute,

  'BelongsToIndustry': BelongsToIndustry,

  'BelongsToWorkspace': BelongsToWorkspace,

  'CatalogAt': CatalogAt,

  'ChangeImpactOfProject': ChangeImpactOfProject,

  'ChangeProposalInBatch': ChangeProposalInBatch,

  'ConcernHasStakeholder': ConcernHasStakeholder,

  'ConnectionEndA': ConnectionEndA,

  'ConnectionEndB': ConnectionEndB,

  'ConstraintHasChildConstraints': ConstraintHasChildConstraints,

  'ContainsAction': ContainsAction,

  'ContainsLogicalPart': ContainsLogicalPart,

  'ContainsPackage': ContainsPackage,

  'ContainsPhysicalPart': ContainsPhysicalPart,

  'ContributesTo': ContributesTo,

  'CreatedBy': CreatedBy,

  'CurrentTaskAttachedTo': CurrentTaskAttachedTo,

  'Derivation': Derivation,

  'DerivedFromUnit': DerivedFromUnit,

  'DerivedValueOfAttribute': DerivedValueOfAttribute,

  'DerivedValueOfExpression': DerivedValueOfExpression,

  'DesignsPackage': DesignsPackage,

  'EditsNode': EditsNode,

  'ExpandsNode': ExpandsNode,

  'ExtractsNode': ExtractsNode,

  'FlowConnection': FlowConnection,

  'Formalises': Formalises,

  'FramesConcern': FramesConcern,

  'GeneratesNode': GeneratesNode,

  'GlossaryTermInWorkspace': GlossaryTermInWorkspace,

  'GroupAt': GroupAt,

  'HasActions': HasActions,

  'HasAnswer': HasAnswer,

  'HasAttribute': HasAttribute,

  'HasAttributeValue': HasAttributeValue,

  'HasConstraints': HasConstraints,

  'HasContentObject': HasContentObject,

  'HasContext': HasContext,

  'HasDerivedValue': HasDerivedValue,

  'HasExpression': HasExpression,

  'HasExpressionInputs': HasExpressionInputs,

  'HasInterfacePort': HasInterfacePort,

  'HasMembers': HasMembers,

  'HasModelRequestResponse': HasModelRequestResponse,

  'HasModelRequests': HasModelRequests,

  'HasPorts': HasPorts,

  'HasProduct': HasProduct,

  'HasQuestionnaire': HasQuestionnaire,

  'HasQuestions': HasQuestions,

  'HasRFLPProject': HasRFLPProject,

  'HasRequirement': HasRequirement,

  'HasRequirements': HasRequirements,

  'HasResponse': HasResponse,

  'HasRootPart': HasRootPart,

  'HasSource': HasSource,

  'HasStakeholderNeed': HasStakeholderNeed,

  'HasSteps': HasSteps,

  'HasSubRequirements': HasSubRequirements,

  'HasSupplyChainCriteria': HasSupplyChainCriteria,

  'HasThread': HasThread,

  'HasThreads': HasThreads,

  'InviteTo': InviteTo,

  'IsPart': IsPart,

  'IslandHoldsPin': IslandHoldsPin,

  'ItemFlowMeasuredIn': ItemFlowMeasuredIn,

  'ItemFlowRealizedBy': ItemFlowRealizedBy,

  'ItemFlowSourceParameter': ItemFlowSourceParameter,

  'ItemFlowTargetParameter': ItemFlowTargetParameter,

  'ItemFlowTypedBy': ItemFlowTypedBy,

  'ItemHasCanonicalUnit': ItemHasCanonicalUnit,

  'ItemInWorkspace': ItemInWorkspace,

  'LPBindsBehavioralPort': LPBindsBehavioralPort,

  'LPHasBehavioralPort': LPHasBehavioralPort,

  'MBSE_Allocates': MBSE_Allocates,

  'MBSE_Attributes': MBSE_Attributes,

  'MBSE_Bind': MBSE_Bind,

  'MBSE_Delegation': MBSE_Delegation,

  'MBSE_Derivation': MBSE_Derivation,

  'MBSE_Flows': MBSE_Flows,

  'MBSE_MainFunction': MBSE_MainFunction,

  'MBSE_Ports': MBSE_Ports,

  'MBSE_Refinement': MBSE_Refinement,

  'MBSE_Requirements': MBSE_Requirements,

  'MBSE_RootPart': MBSE_RootPart,

  'MBSE_Satisfaction': MBSE_Satisfaction,

  'MBSE_SubactionOf': MBSE_SubactionOf,

  'MBSE_SubpartOf': MBSE_SubpartOf,

  'MemberOf': MemberOf,

  'MemberOfClosure': MemberOfClosure,

  'Mentions': Mentions,

  'NeedHasStakeholder': NeedHasStakeholder,

  'NeedTransformedToRequirement': NeedTransformedToRequirement,

  'NumericAttributeHasCanonicalUnit': NumericAttributeHasCanonicalUnit,

  'OfIsland': OfIsland,

  'OperatesOn': OperatesOn,

  'OwnedByUser': OwnedByUser,

  'Owns': Owns,

  'ParentScope': ParentScope,

  'PartBindsInterfacePort': PartBindsInterfacePort,

  'PartComposedOf': PartComposedOf,

  'Performs': Performs,

  'ProjectHasRootPart': ProjectHasRootPart,

  'ProposalBatchFromChangeImpact': ProposalBatchFromChangeImpact,

  'ProposalBatchOfProject': ProposalBatchOfProject,

  'RFLPAllocation': RFLPAllocation,

  'RFLPPerforms': RFLPPerforms,

  'RealizedByProject': RealizedByProject,

  'RealizesConnection': RealizesConnection,

  'ReferencesNode': ReferencesNode,

  'Refinement': Refinement,

  'RequirementConflictsWith': RequirementConflictsWith,

  'RequirementDerives': RequirementDerives,

  'RequirementHasStakeholder': RequirementHasStakeholder,

  'RequirementPart': RequirementPart,

  'RequirementRefines': RequirementRefines,

  'Satisfaction': Satisfaction,

  'Satisfies': Satisfies,

  'SourceDocumentInWorkspace': SourceDocumentInWorkspace,

  'Specializes': Specializes,

  'StandardForInterfacePort': StandardForInterfacePort,

  'StandardInWorkspace': StandardInWorkspace,

  'SubTaskOf': SubTaskOf,

  'SuccessionScopedIn': SuccessionScopedIn,

  'SuccessionSourceAction': SuccessionSourceAction,

  'SuccessionTargetAction': SuccessionTargetAction,

  'ToolResponsesSentIn': ToolResponsesSentIn,

  'TriggeredByToolCall': TriggeredByToolCall,

  'UnitInWorkspace': UnitInWorkspace,

  'UsesSystemPromptForRequest': UsesSystemPromptForRequest,

  'WritesTo': WritesTo,

};

/**
 * Get relationship metadata class by Neo4j type name
 * @param relType - Neo4j relationship type (e.g., 'HasSteps')
 * @returns Relationship metadata class or undefined if not found
 */
export function getRelationshipClass(relType: string): RelationshipClass | undefined {
  return RelationshipRegistry[relType];
}

/**
 * Get property name for a relationship type
 * @param relType - Neo4j relationship type (e.g., 'HasSteps')
 * @param reverse - If true, return destination property name instead of origin
 * @returns Property name (e.g., 'steps') or undefined if not found
 */
export function getRelationshipPropertyName(relType: string, reverse: boolean = false): string | undefined {
  const RelClass = RelationshipRegistry[relType];
  if (!RelClass) return undefined;

  // Access static properties directly from the class
  return reverse ? RelClass.dest_property : RelClass.origin_property;
}